const {
  NEXT_PUBLIC_CONTENTFUL_ENV,
  NEXT_PUBLIC_CONTENTFUL_SPACE_ID,
  NEXT_PUBLIC_CONTENTFUL_ACCESS_TOKEN,
  NEXT_PUBLIC_CONTENTFUL_PREVIEW_ACCESS_TOKEN,
} = process.env;

// Contentful configuration using Next.js env injection
export const contentfulConfig = {
  // These are injected by Next.js from server env vars for both client and server
  environment: getContentfulEnv(),
  spaceId: NEXT_PUBLIC_CONTENTFUL_SPACE_ID || '',
  accessToken: NEXT_PUBLIC_CONTENTFUL_ACCESS_TOKEN || '',
  previewAccessToken: NEXT_PUBLIC_CONTENTFUL_PREVIEW_ACCESS_TOKEN || '',
};

// Get Contentful env
function getContentfulEnv() {
  return NEXT_PUBLIC_CONTENTFUL_ENV || 'master';
}
